import React from 'react';
import { createSvgIcon } from './utils';
export default createSvgIcon(React.createElement("g", null,
    React.createElement("path", { d: "M33,30c0,0-19,19-20,20s-3-1-2-2s18-18,18-18S12,13,11,12s1-3,2-2S33,30,33,30z M49,11c0,2,0,36,0,38s-3,2-3,0s0-36,0-38S49,9,49,11z" })), 'Start', '6 6 49 49');
//# sourceMappingURL=EndIcon.js.map